export enum RabbitStatus {
  IN_PROD = 'IN_PROD',
  WASTE_CANDIDATE = 'WASTE_CANDIDATE',
  WASTE = 'WASTE',
  SOLD = 'SOLD',
  DEAD = 'DEAD',
}
